import { readAskLink, type GateAskLink } from "@yagni/shared";

/** The approve gate's person-only steps, as the plan gate wrote them. Total: anything unreadable is dropped. */
export function readPersonOnlySteps(
  payload: unknown,
): Array<{ step: number; why: string; link: GateAskLink | null }> {
  const raw =
    payload && typeof payload === "object" && !Array.isArray(payload)
      ? (payload as Record<string, unknown>).personOnlySteps
      : null;
  if (!Array.isArray(raw)) return [];
  return raw.flatMap((entry) => {
    if (!entry || typeof entry !== "object") return [];
    const row = entry as Record<string, unknown>;
    if (typeof row.step !== "number" || typeof row.why !== "string" || !row.why.trim()) return [];
    return [{ step: row.step, why: row.why.trim(), link: readAskLink(row.link) }];
  });
}
